import styles from "../../../../styles/sections/admin/car_parking/CarParkingForm.module.css";
import { useState } from "react";
import FormDropDown from "../../../common/form_dropdown/FormDropDown";
import ActionButton from "../../../common/action_button/ActionButton";
import AddIcon from "../../../../assets/common/add_icon.svg";

const SetupExpenseForm = ({
  form_fields,
  handleFieldChange,
  currentExpenseId = 0,
  setOpenFormModal,
  formHandler,
}) => {
  return (
    <div className={styles.form_modal}>
      <form className={styles.form_container}>
        <div className={styles.header}>
          <div className={styles.title}>
            {currentExpenseId === 0 ? "Add" : "Edit"} Setup Expense
          </div>
          <button
            onClick={() => {
              setOpenFormModal(false);
            }}
            className={styles.close_handler}
          >
            X
          </button>
        </div>
        <div className={styles.form__components}>
          {form_fields.map((item, index) => {
            return (
              <div className={styles.input_wrap} key={index}>
                <label className={styles.input_name}>{item.field_name}</label>
                {(item.type === "text" ||
                  item.type === "number" ||
                  item.type === "date" ||
                  item.type === "email" ||
                  item.type === "address") && (
                  <input
                    className={
                      `${styles.input_field}  ${styles.field}` +
                      " " +
                      (item.error ? styles.field_error : "")
                    }
                    type={item.type}
                    // onChange={(event) => {
                    //   item.value = event.target.value;
                    // }}
                    onChange={(event) => {
                      handleFieldChange(
                        item.field_id,
                        event.target.value,
                        false,
                        ""
                      );
                    }}
                    placeholder={item.placeholder}
                    value={item.value}
                  />
                )}

                {item.error && (
                  <p className={styles.error_message}>{item.error_message}</p>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles.footer}>
          <ActionButton
            buttonText={
              (currentExpenseId === 0 ? "Add" : "Update") + " Setup Expense"
            }
            icon={AddIcon}
            onClick={formHandler}
          />
        </div>
      </form>
    </div>
  );
};

export default SetupExpenseForm;
